<script setup lang="ts">
import { STORYBLOK_ROUTES } from '#shared/constants/storyblok';

// COMPOSABLES
const { headerMenuItems } = await useStoryblokGlobalConfig();

// DATA
const isMobileMenuOpen = ref(false);
</script>

<template>
    <nav class="sticky inset-x-0 top-(--announcement-bar-height) z-40 flex w-full items-center justify-center bg-white ring-1 ring-neutral-300">
        <BaseWidthContainer as="header" class="relative z-40 flex h-(--header-height) flex-row flex-nowrap items-center justify-between gap-4">
            <div class="flex items-center gap-6">
                <NuxtLinkLocale :to="STORYBLOK_ROUTES.HOMEPAGE" @click="isMobileMenuOpen = false">
                    <SvgoFleequidLogo class="text-primary h-[26px]" :font-controlled="false" />
                </NuxtLinkLocale>

                <!-- Desktop/Tablet -->
                <UNavigationMenu
                    color="neutral"
                    arrow
                    content-orientation="vertical"
                    :items="headerMenuItems"
                    class="hidden w-full justify-center lg:flex"
                    :ui="{ content: 'w-auto' }"
                    :external-icon="false"
                />
            </div>

            <div class="flex items-center lg:gap-3">
                <HeaderSearchDockedButton class="hidden lg:inline-flex" />
                <HeaderSearchFullscreenButton class="lg:hidden" />

                <LangSwitch />

                <HeaderAccountMenu class="hidden lg:block" />

                <HeaderMenuBurgerButton v-model:open="isMobileMenuOpen" class="lg:hidden" />
            </div>
        </BaseWidthContainer>
    </nav>
    <HeaderMenuMobile v-model:open="isMobileMenuOpen" />
</template>
